import type { UserUpdate } from '../../generated/users'
import type { UserFormType } from '../../models'

export const formatUser = (user: UserFormType): UserUpdate => ({
  first_name: user.firstName,
  last_name: user.lastName,
  user_persona: user.userPersona || null,
  email: user.email,
  group_id: user.group,
  default_metrics_config_id: user.defaultMetricsConfigId,
})
